import { FIELDS, TABS, TAB_VIEW_SECTIONS } from '../../../constants';

export const { ADVANCED } = TABS;
export const { CROSS_SELL, GUEST_CARD_REQUIREMENTS, SELF_GUIDED_TOURS } =
  TAB_VIEW_SECTIONS[ADVANCED];

export const { [CROSS_SELL]: CROSS_SELL_FIELDS } = FIELDS[ADVANCED];

export const GUEST_CARD_REQUIREMENTS_FIELDS = Object.values(
  FIELDS[ADVANCED][GUEST_CARD_REQUIREMENTS],
);

const SELF_GUIDED_TOURS_FIELD_NAMES = FIELDS[ADVANCED][SELF_GUIDED_TOURS];

export const SELF_GUIDED_TOURS_FIELDS = Object.values(
  SELF_GUIDED_TOURS_FIELD_NAMES,
);

export { SELF_GUIDED_TOURS_FIELD_NAMES };

export const VALIDATION_ERROR_MESSAGES = {
  INVALID_URL: 'Specified website is invalid',
};
